/* Anwendungs-Slider: natives Scroll-Snap, Pfeile, Zähler, Fortschritt.
   Der Track scrollt ohne JS (Touch/Trackpad); dieses Skript ergänzt nur
   Tastatur, Pfeile und die Anzeige. */
(function () {
  var root = document.querySelector('[data-apps]');
  if (!root) return;

  var track = root.querySelector('[data-apps-track]');
  if (!track) return;
  var cards = Array.prototype.slice.call(track.children);
  var prevBtn = root.querySelector('[data-apps-prev]');
  var nextBtn = root.querySelector('[data-apps-next]');
  var numOut = root.querySelector('[data-apps-num]');
  var bar = root.querySelector('[data-apps-bar]');

  function schritt() {
    if (cards.length > 1) return cards[1].offsetLeft - cards[0].offsetLeft;
    return cards[0] ? cards[0].getBoundingClientRect().width : 320;
  }

  function indexJetzt() {
    var s = schritt();
    if (!s) return 0;
    return Math.max(0, Math.min(cards.length - 1, Math.round(track.scrollLeft / s)));
  }

  function aktualisiere() {
    var i = indexJetzt();
    if (numOut) numOut.textContent = String(i + 1).padStart(2, '0');
    var max = track.scrollWidth - track.clientWidth;
    if (bar) bar.style.width = (max > 0 ? (track.scrollLeft / max) * 100 : 0) + '%';
    if (prevBtn) prevBtn.disabled = track.scrollLeft <= 2;
    if (nextBtn) nextBtn.disabled = max <= 2 || track.scrollLeft >= max - 2;
  }

  function scroll(dx) {
    track.scrollBy({ left: dx, behavior: 'smooth' });
  }

  if (nextBtn) nextBtn.addEventListener('click', function () { scroll(schritt()); });
  if (prevBtn) prevBtn.addEventListener('click', function () { scroll(-schritt()); });

  track.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowRight') { e.preventDefault(); scroll(schritt()); }
    if (e.key === 'ArrowLeft') { e.preventDefault(); scroll(-schritt()); }
  });

  track.addEventListener('scroll', function () {
    window.requestAnimationFrame(aktualisiere);
  }, { passive: true });

  window.addEventListener('resize', aktualisiere);
  aktualisiere();
})();
